import Hammer from 'hammerjs'

let document_font_size = document.querySelector('#m-space-measure')?.clientWidth || 16
console.log(`document_font_size: ${document_font_size}`)
let new_font_size = 16

export const init_pinch_zoom = () => {
    const zoomer = new Hammer(document.body)
    zoomer.get('pinch').set({ enable: true });

    zoomer.on('pinch', (event) => {
        console.log(event.scale)
        const scaling_factor = ((event.scale - 1) * 0.3) + 1
        new_font_size = document_font_size * scaling_factor
        document.body.style.fontSize = new_font_size + 'px'
    })

    zoomer.on('pinchend', () => {
        document_font_size = new_font_size
    })

    window.addEventListener('keydown', (e) => {
        if (e.key === '+') {
            const scaling_factor = 1.05
            new_font_size = document_font_size * scaling_factor
            document.body.style.fontSize = new_font_size + 'px'
            document_font_size = new_font_size
        }
        if (e.key === '-') {
            const scaling_factor = 0.95
            new_font_size = document_font_size * scaling_factor
            document.body.style.fontSize = new_font_size + 'px'
            document_font_size = new_font_size
        }
    })
}